import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ResourceLocationInfo
*  Информация о ссылке на файл ресурса
*/
export class ResourceLocationInfo extends ActiveModel {

/**
  * uri
  * Ссылка на файл ресурса<br>
  */
  @ActiveField('')
  uri: string = ''
}
